{
  "invite.title": "Velkommen til ColorGlo",
  "invite.body": "Velg et passord, så er du i gang.",
  "invite.name": "Navnet ditt",
  "invite.password": "Passord",
  "invite.password_hint": "Minst 12 tegn.",
  "invite.submit": "Opprett kontoen",
  "invite.done": "Kontoen er klar. Logg inn, så kommer du til kalenderen.",
  "invite.missing": "Lenken mangler en invitasjon. Be sjefen din om en ny.",
  "auth.sign_in.title": "Logg inn",
  "auth.sign_in.body": "Logg inn for å komme til kalenderen.",
  "auth.sign_in.email": "E-postadresse",
  "auth.sign_in.password": "Passord",
  "auth.sign_in.submit": "Logg inn",
  "auth.sign_in.working": "Logger inn …",
  "auth.sign_in.failed": "E-postadressen eller passordet stemmer ikke.",
  "auth.sign_in.forgot": "Glemt passordet?",
  "auth.sign_in.no_account": "Ingen konto ennå? Be franchisetakeren din om en invitasjon.",
  "auth.sign_in.image_alt": "Arbeid i et ColorGlo-verksted",
  "auth.sign_out": "Logg ut",
  "auth.email.invitation.subject": "Du er invitert til {workshop}",
  "auth.email.invitation.heading": "Velkommen til {workshop}",
  "auth.email.invitation.body": "Du er invitert til bookingkalenderen for {workshop}. Velg et passord for å komme i gang. Lenken gjelder i 14 dager.",
  "auth.email.invitation.cta": "Opprett kontoen din",
  "auth.email.password_reset.subject": "Velg et nytt passord for ColorGlo",
  "auth.email.password_reset.heading": "Nytt passord",
  "auth.email.password_reset.body": "{workshop} har sendt deg en lenke for å velge et nytt passord. Lenken gjelder i 24 timer og kan bare brukes én gang.",
  "auth.email.password_reset.cta": "Velg nytt passord",
  "auth.email.email_changed.subject": "Innloggingen din til ColorGlo er endret",
  "auth.email.email_changed.heading": "Ny e-postadresse for innlogging",
  "auth.email.email_changed.body": "{workshop} har endret e-postadressen du logger inn med. Kontakt lederen din hvis du ikke kjenner igjen endringen.",
  "auth.email.email_changed.cta": "Logg inn",
  "reset.title": "Velg et nytt passord",
  "reset.body": "Det nye passordet erstatter det gamle. Du blir logget ut på alle enheter.",
  "reset.password": "Nytt passord",
  "reset.password_hint": "Minst 12 tegn.",
  "reset.submit": "Lagre passordet",
  "reset.done": "Passordet er lagret. Logg inn med det nye passordet.",
  "reset.missing": "Lenken mangler en tilbakestilling. Be lederen din om en ny.",
  "reset.failed": "Lenken virker ikke lenger. Be lederen din om en ny.",
  "invite.owner_title": "Velkommen, {name}",
  "invite.owner_body": "Velg et passord for verkstedets konto.",
  "invite.email": "E-post",
  "invite.activate_body": "Kontoen finnes allerede. Aktiver for å legge til {name}.",
  "invite.activate": "Aktiver",
  "invite.invalid": "Invitasjonen er ugyldig eller utløpt. Be om en ny.",
  "auth.change_password.title": "Bytt passord",
  "auth.change_password.body": "De andre innloggingene dine logges ut når passordet er byttet.",
  "auth.change_password.current": "Nåværende passord",
  "auth.change_password.new": "Nytt passord",
  "auth.change_password.confirm": "Gjenta nytt passord",
  "auth.change_password.mismatch": "Passordene stemmer ikke overens.",
  "auth.change_password.failed": "Nåværende passord stemmer ikke.",
  "auth.change_password.submit": "Bytt passord",
  "auth.change_password.done": "Passordet er byttet."
}
